import React from 'react';
import Modal from 'react-modal';
import AlertIcon from '../../assets/icons/icon-alert-large.png';
import styles from './styles';

Modal.setAppElement('#root');

interface AlertModalProps {
  title: string | null;
  content: string | JSX.Element | null;
  isOpen: boolean;
  canClose?: boolean;
  closeModal?(event: (React.MouseEvent | React.KeyboardEvent)): void;
}

export const AlertModal: React.FC<AlertModalProps> = (props) => {
  const {
    title,
    content,
    isOpen,
    canClose = true,
    closeModal = () => null,
  } = props;

  return (
    <Modal
      shouldCloseOnEsc={canClose}
      shouldCloseOnOverlayClick={canClose}
      isOpen={isOpen}
      onRequestClose={closeModal}
    >
      <div className={styles.modal}>
        <div className={styles.modalIcon}>
          <img src={AlertIcon} alt="" className={styles.iconLarge} />
        </div>
        <div className={styles.modalText}>
          <h1 className={styles.title}>{title}</h1>
          <div className={styles.spacer5}></div>
          <div className={styles.text}>{content}</div>
        </div>
      </div>
    </Modal>
  );
};

export default AlertModal;
